import isEmpty from 'lodash/isEmpty';
import { Content } from 'pleinchamp-api-client/dist/src/content/search';
import React, { ComponentPropsWithRef, FC } from 'react';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import { insertAdvertInArray } from '@adverts/business/adverts.utils';
import { ContentCardLoader } from '@components/content/ContentCard/ContentCardLoader.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { useIsSSO } from '@user/business/User.store';
import { buildContentCard } from '@utils/card';
import classnames from 'classnames';

interface Props extends ComponentPropsWithRef<'section'> {
  news: Content[];
  isLoading?: boolean;
  i18nTitle?: string;
  className?: string;
}

const FeaturedNews: FC<Props> = ({
  news,
  i18nTitle = 'common.highlighted-articles',
  isLoading = false,
  className,
  ...rest
}) => {
  const rootClass = classnames('wrapper-s', className);
  const isSSO = useIsSSO();
  const isMobile = useIsBreakpointDown(Breakpoint.s);
  if (isSSO) {
    return null;
  }
  if (isLoading) {
    return (
      <section className={rootClass} {...rest}>
        <Text className="plc-mb-basis plc-mb-up-m-l" i18nKey={i18nTitle} tag="h2" variant="h3" />
        <div className="grid-l-3-m-2-s-1">
          <ContentCardLoader uniqueKey="featuredNew1" />
          <ContentCardLoader uniqueKey="featuredNew2" />
        </div>
      </section>
    );
  }

  if (!news || isEmpty(news)) {
    return null;
  }
  const newsWithAd = insertAdvertInArray(
    news.map((item) => buildContentCard(item, isMobile)),
    2,
    3,
    ADVERT_FORMAT_ID.NativeAdBis
  );
  return (
    <section className={rootClass} {...rest}>
      <Text className="plc-mb-basis plc-mb-up-m-l" i18nKey={i18nTitle} tag="p" variant="new-h3" />
      <div className="grid-l-3-m-2-s-1">{newsWithAd}</div>
    </section>
  );
};

export { FeaturedNews };
